import { useState, useEffect } from "react";
import axios from "axios";

const useCurrentUser = () => {
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get("/auth/me")
      .then((res) => {
        setUser(res.data);
        setPermissions(res.data.permissions ?? []);
      })
      .catch(() => {
        setUser(null);
        setPermissions([]);
      })
      .finally(() => setLoading(false));
  }, []);

  return { user, permissions, loading };
};

export default useCurrentUser;
